<template>
  <div class="login-card__verification-phone">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.verification.phone.header') }}</h1>
      <p class="login-card__title-desc"> {{ trans.get('auth.card.verification.phone.subheader') }}</p>
    </div>
    <div v-if="codeResent">
      <p class="login-card__verification-success">{{ trans.get('auth.card.verification.phone.code_successfully_resent') }}</p>
    </div>
    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-group mt-5 mt-md-3">
            <validation-provider name="phone verification code" rules="required" v-slot="{ errors }" mode="eager">
              <label for="phone-verification-code"></label>
              <input
                type="text"
                id="phone-verification-code"
                class="input-code"
                v-model="phoneVerificationCode"
                v-input-mask data-inputmask-mask="* * * *"
                data-inputmask-placeholder="_ _ _ _"
                data-inputmask-clearMaskOnLostFocus="false"
                @paste="onPaste"
              >
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>

          <button type="button" class="button button__outline mb-3 px-3" @click="resendCode">{{ trans.get('auth.card.buttons.resend_pin_code') }}</button>

          <button type="submit" class="button button__fill button--w-100 mt-5">{{ trans.get('auth.card.buttons.continue') }}</button>
        </form>
      </validation-observer>

      <button type="button" class="button button__link button__link--underline mt-3" @click="logout">{{ trans.get('auth.card.buttons.logout') }}</button>
    </div>
    <p class="login-card__btn-desc" v-html="trans.get('auth.card.registration_agreement', {link1: '/abgn', link2: '/privacy'})"></p>
  </div>
</template>
<script>
export default {
  props: ['swapComponent'],
  data: () => ({
    phoneVerificationCode: '',
    userId: '',
    codeResent: false,
  }),
  methods: {
    onSubmit() {
      const self = this;
      axios
        .get(zRoute('verification.phone.verify', [this.userId, this.trimmedCode]))
        .then(function (response) {
          if (response.data.status === 'success') {
            self.swapComponent('auth-name-card');
          } else if (response.status === 204) {
            self.swapComponent('auth-name-card');
          }
        }, function (error) {
          if (error.response.status === 422) {
            self.$refs.form.setErrors(error.response.data.errors);
          } else if (error.response.status === 403) {
            self.$refs.form.setErrors({ code: ['Wrong PIN code'] });
          }
        });
    },
    resendCode() {
      const self = this;
      axios
        .post(zRoute('verification.phone.resend'))
        .then(function (response) {
          self.codeResent = true;
        }, function (error) {
          self.codeResent = false;
          if (error.response.status === 422) {
            self.$refs.form.setErrors(error.response.data.errors);
          }
        });
    },
    logout() {
      const self = this;
      axios
        .post(zRoute('logout'))
        .then(function (response) {
          self.swapComponent('auth-welcome-card');
        }, function (error) {
          //
        });
    },
    getUser() {
      const self = this;
      axios
        .get(zRoute('ajax.auth.users.show'))
        .then(function (response) {
          self.userId = response.data.data.id;
        }, function (error) {
          //
        });
    },
    async refreshCSRFToken() {
      axios
        .get(zRoute('ajax.csrf_token'))
        .then(response => {
          const token = response.data.csrfToken;
          document.querySelector('meta[name=csrf-token]').setAttribute('content', token);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        });
    },
    onPaste: function (event) {
      this.phoneVerificationCode = event.clipboardData.getData('text');
    },
  },
  computed: {
    trimmedCode: function () {
      return this.phoneVerificationCode.replace(/\s+/g, '');
    },
  },
  activated() {
    this.getUser();
    this.codeResent = false;
    this.refreshCSRFToken();
  }
};
</script>
<style scoped>
</style>
